module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-nausea-svgrepo-com.a1e62293.svg";